var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"label":"Datum narození","type":"date","name":"birthDate","value":_vm.value,"help":_vm.help,"max":_vm.getMaxDate(),"min":_vm.getMinDate(),"validation":"date","validation-rules":{ date: _vm.dateRule },"validation-messages":{ date: 'Minimální věk je 15 let' },"error-behavior":"submit","disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }